// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: '28adc71ca3af1fd4c5b35fca029146f8c8eae1dc',
  buildTime: '2026-07-16T14:33:32.512Z',
} as const;
